import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const HotspotTemplateRoutes = defineRoute({
    record: {
        route: {
            path: "/hotspot-template",
            component: () => loadView(import("./HotspotTemplateTable.vue")),
        },
    },
    create: {
        route: {
            path: "/hotspot-template/create",
            component: () => loadView(import("./HotspotTemplateCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/hotspot-template/:id",
            component: () => loadView(import("./HotspotTemplateDetail.vue")),
        },
        build(id: string) {
            return `/hotspot-template/${id}`;
        },
    },
});
